import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  Chip,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Popover,
  Typography,
  List,
  ListItem,
  Checkbox,
  withStyles,
  Fade,
  IconButton,
  Tooltip
} from '@material-ui/core';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import { Pagination } from '@material-ui/lab';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import DialogConfirm from 'src/app/components/DialogConfirm';
import { closeDialogConfirm, showDialogConfirm } from 'src/features/uiSlice';
import { MESSAGE } from 'src/app/constant/message';
import { PAGE_SIZE_LIST } from 'src/app/constant/config';
import { _convertObjectToQuery } from 'src/app/utils/apiService';
import { useDispatch } from 'react-redux';
import {
  deleteMultiAgency,
  getListAgencies
} from 'src/features/agencySlice';
import { resetPasswordCustomer, updateUser } from 'src/features/userSlice';
import EditAgency from './EditAgency';
import WarehouseTransfer from './warehouseTransfer';
import ConfigServicePackageModal from './ConfigServicePackageModal';
import TopupAgencyModal from './TopupAgencyModal';
import AgencyConfigModal from './AgencyConfigModal';
import { useTheme, useMediaQuery } from '@material-ui/core';
import AgencyAccountInfoDialog from './AgencyAccountInfoDialog';
import { formatMoney } from 'src/app/utils/commomService';
import { useDragScroll } from 'src/app/hooks/useDragScroll';

const CHECKBOX_COL_WIDTH = 56;
const COLUMN_WIDTHS = [
  CHECKBOX_COL_WIDTH, // Checkbox
  320, // Tên đại lý
  120, // Số điện thoại
  120, // Tên đăng nhập
  180, // Tên doanh nghiệp
  100, // Mã số thuế
  160, // Email
  400, // Địa chỉ
  100, // Tỉnh thành
  120, // Số dư Vxu
  100, // Đã kích hoạt
  80, // Thiết bị
  120, // Tổng đã mua
  120, // Đã trả
  120, // Dư nợ
  140, // Trạng thái
  80 // Hành động
];

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    whiteSpace: 'nowrap'
  },
  body: {
    fontSize: 14,
    wordBreak: 'break-word'
  },
  root: {
    padding: '6px'
  }
}))(TableCell);

const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return '0 Vxu';
  return Number(amount).toLocaleString('vi-VN') + ' Vxu';
};

const toFiniteNumber = value => {
  if (value === null || value === undefined || value === '') return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

const formatAgencyMoney = amount => {
  const number = toFiniteNumber(amount);
  return number === null ? '-' : formatMoney(number);
};

// Dư nợ = Tổng đã mua - Đã trả; null khi API không trả về số liệu nào
const getAgencyDebt = money => {
  const total = toFiniteNumber(money?.total_amount_sum);
  const paid = toFiniteNumber(money?.total_paid_sum);
  if (total === null && paid === null) return null;
  return (total ?? 0) - (paid ?? 0);
};

const getPasswordFromResponse = data => {
  return data?.payload?.password ||
    '123456';
};

const Results = ({
  className,
  totalAgencies,
  listAgencies,
  getListAgenciesRef,
  currentParams
}) => {
  const dispatch = useDispatch();
  const isAdmin = useSelector(state => state.authSlice.isAdmin);
  const isAccountant = useSelector(state => state.authSlice.isAccountant);
  const isSale = useSelector(state => state.authSlice.isSale);
  const isLeadMarketing = useSelector(state => state.authSlice.isLeadMarketing);
  const isAgency = useSelector(state => state.authSlice.isAgency);
  const isCustomerCare = useSelector(state => state.authSlice.isCustomerCare);
  const canManage = Boolean(isAdmin || isSale || isLeadMarketing || isAgency);

  const listProvinces = useSelector(state => state.provinceSlice.listProvinces);
  const classes = useStyles();
  const dragScrollRef = useDragScroll();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const limit = isMobile ? 6 : PAGE_SIZE_LIST;
  const [page, setPage] = useState(1);
  const [selectedItem, setSelectedItem] = useState();
  const [selectedLeaderId, setSelectedLeaderId] = useState();
  const [itemCurrent, setItemCurrent] = useState();
  const [rowsSelected, setRowsSelected] = useState([]);
  const [confirmType, setConfirmType] = useState(null);
  const [expandedRows, setExpandedRows] = useState({});
  const [isScrolledX, setIsScrolledX] = useState(false);
  const stickyNameClass = isScrolledX ? classes.stickyName : undefined;
  const stickyCheckboxClass = isScrolledX ? classes.stickyCheckbox : undefined;

  const toggleExpand = id => {
    setExpandedRows(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const navigate = useNavigate();

  const [params, setParams] = useState({
    page: page,
    page_size: limit
  });

  const handleClickMenu = (event, agency) => {
    setAnchorEl(event.currentTarget);
    setItemCurrent({
      id: agency.id,
      leader_id: agency.leader?.id,
      leader: agency.leader,
      name: agency.name,
      username: agency.leader?.username,
      business_name: agency.leader?.business_name,
      tax_code: agency.leader?.tax_code,
      email: agency.leader?.email,
      address: agency.leader?.address,
      phone: agency.leader?.phone,
      business_id: agency.business?.id,
      province_id: agency.leader?.citizen_id,
      status: agency.leader?.status
    });

    setSelectedItem(agency.id);
    setSelectedLeaderId(agency.leader?.id);
  };
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openTransferModal, setOpenTransferModal] = useState(false);
  const [openConfigPackageModal, setOpenConfigPackageModal] = useState(false);
  const [openTopupModal, setOpenTopupModal] = useState(false);
  const [openAgencyConfigModal, setOpenAgencyConfigModal] = useState(false);
  const [accountInfo, setAccountInfo] = useState(null);

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);

  const handleEditAgency = () => {
    setOpenEditModal(true);
    handleCloseMenu();
  };

  const handleWarehouseTransfer = () => {
    setOpenTransferModal(true);
    handleCloseMenu();
  };

  const handleConfigServicePackage = () => {
    setOpenConfigPackageModal(true);
    handleCloseMenu();
  };

  const closeModalEdit = () => {
    setOpenEditModal(false);
  };
  const closeModalTransfer = () => {
    setOpenTransferModal(false);
  };
  const closeModalConfigPackage = () => {
    setOpenConfigPackageModal(false);
  };
  const handleOpenDeviceWarehouse = () => {
    handleCloseMenu();
    const queryString = _convertObjectToQuery({
      agency_id: selectedItem,
      page: 1,
      page_size: PAGE_SIZE_LIST
    });
    navigate(`/app/manage/devices?${queryString}`);
  };
  const handleOpenTopupModal = () => {
    setOpenTopupModal(true);
    handleCloseMenu();
  };
  const closeModalTopup = () => {
    setOpenTopupModal(false);
  };


  const handleDeleteAgency = () => {
    setConfirmType('delete');
    dispatch(showDialogConfirm());
    handleCloseMenu();
  };

  const handleDeleteMultiAgency = () => {
    setConfirmType('delete');
    dispatch(showDialogConfirm());
    handleCloseMenu();
  };

  const handleResetPassword = () => {
    setConfirmType('reset-password');
    dispatch(showDialogConfirm());
    handleCloseMenu();
  };

  const handleDisableAgency = () => {
    setConfirmType('disable');
    dispatch(showDialogConfirm());
    handleCloseMenu();
  };

  const handleEnableAgency = () => {
    setConfirmType('enable');
    dispatch(showDialogConfirm());
    handleCloseMenu();
  };

  const handleOpenAgencyConfig = () => {
    setOpenAgencyConfigModal(true);
    handleCloseMenu();
  };

  const confirmDelete = () => {
    const listId = rowsSelected?.length > 0 ? rowsSelected : [selectedItem];
    setRowsSelected([]);
    setConfirmType(null);
    dispatch(closeDialogConfirm());
    dispatch(deleteMultiAgency({ agency_ids: listId }));
  };

  const confirmDisable = () => {
    setConfirmType(null);
    dispatch(closeDialogConfirm());
    if (!itemCurrent?.leader?.id) return;
    dispatch(updateUser({ id: itemCurrent.leader.id, data: { status: 3 } })).then(action => {
      if (updateUser.fulfilled.match(action)) {
        dispatch(getListAgencies(currentParams));
      }
    });
  };

  const confirmEnable = () => {
    setConfirmType(null);
    dispatch(closeDialogConfirm());
    if (!itemCurrent?.leader?.id) return;
    dispatch(updateUser({ id: itemCurrent.leader.id, data: { status: 1 } })).then(action => {
      if (updateUser.fulfilled.match(action)) {
        dispatch(getListAgencies(currentParams));
      }
    });
  };

  const confirmResetPassword = () => {
    setConfirmType(null);
    dispatch(closeDialogConfirm());
    dispatch(resetPasswordCustomer({ id: selectedLeaderId })).then(action => {
      if (resetPasswordCustomer.fulfilled.match(action)) {
        setAccountInfo({
          username: itemCurrent?.username || '',
          password: getPasswordFromResponse(action.payload)
        });
      }
    });
  };

  const handleCloseDialogConfirm = () => {
    setConfirmType(null);
    dispatch(closeDialogConfirm());
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    if (!getListAgenciesRef) return;
    const newParams = {
      ...currentParams,
      page: newPage,
      page_size: limit
    }
    setParams(newParams);
    getListAgenciesRef(newParams);
  };

  const checked = id => {
    return rowsSelected.indexOf(id) !== -1;
  };
  const select = driver => {
    if (rowsSelected.indexOf(driver) === -1) {
      const newSelected = [driver, ...rowsSelected];
      setRowsSelected(newSelected);
    } else {
      const newSelected = rowsSelected.filter(i => i !== driver);
      setRowsSelected(newSelected);
    }
  };

  const getAllAgencyIds = () => {
    const ids = [];
    listAgencies?.forEach(item => {
      ids.push(item.id);
      if (item.children && item.children.length > 0) {
        item.children.forEach(child => ids.push(child.id));
      }
    });
    return ids;
  };

  const checkAll = () => {
    const allIds = getAllAgencyIds();
    if (rowsSelected.length > 0) {
      setRowsSelected([]);
    } else if (allIds.length > 0) {
      setRowsSelected(allIds);
    }
  };

  const getProvinceAddress = citizenId => {
    const province = listProvinces?.find(
      province => province.id === +citizenId
    );
    return province?.name;
  };

  const renderStatusCell = item => (
    <StyledTableCell>
      <Chip
        size="small"
        label={
          Number(item?.leader?.status) === 3
            ? 'Vô hiệu hóa'
            : 'Đang hoạt động'
        }
        className={clsx(
          classes.statusChip,
          Number(item?.leader?.status) === 3
            ? classes.statusChipDisabled
            : classes.statusChipActive
        )}
      />
    </StyledTableCell>
  );

  const renderActionsCell = (item, backgroundColor = '#fff') => (
    <StyledTableCell className={classes.stickyAction} style={{ backgroundColor }}>
      {!isCustomerCare && (
        <span style={{ color: '#AEB1C5' }}>
          <MoreVertIcon
            aria-describedby={`menu-device-${item.id}`}
            className={`cursor-pointer hover-red`}
            onClick={e => handleClickMenu(e, item)}
          />
        </span>
      )}

      <Popover
        id={`menu-device-${item.id}`}
        className="popover-device"
        PaperProps={{ className: classes.actionMenuPaper }}
        open={open && selectedItem === item.id}
        anchorEl={anchorEl}
        onClose={handleCloseMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <Typography>
          <List>
            {canManage && (
              <>
                <ListItem
                  onClick={handleResetPassword}
                  className="border-bottom list-menu-device cursor-pointer"
                >
                  Reset mật khẩu
                </ListItem>
                <ListItem
                  onClick={handleEditAgency}
                  className="border-bottom list-menu-device cursor-pointer"
                >
                  Chỉnh sửa
                </ListItem>
                {isAdmin && (
                  Number(item?.leader?.status) === 3 ? (
                    <ListItem
                      onClick={handleEnableAgency}
                      className="border-bottom list-menu-device cursor-pointer"
                    >
                      Khôi phục tài khoản
                    </ListItem>
                  ) : (
                    <ListItem
                      onClick={handleDisableAgency}
                      className="border-bottom list-menu-device cursor-pointer"
                    >
                      Vô hiệu hóa tài khoản
                    </ListItem>
                  )
                )}
                {isAdmin && (
                  <>
                    <ListItem
                      onClick={handleOpenTopupModal}
                      className="border-bottom list-menu-device cursor-pointer"
                    >
                      Nạp Vxu
                    </ListItem>
                    <ListItem
                      onClick={handleConfigServicePackage}
                      className="border-bottom list-menu-device cursor-pointer"
                    >
                      Cấu hình gói cước
                    </ListItem>
                    <ListItem
                      onClick={handleOpenAgencyConfig}
                      className="border-bottom list-menu-device cursor-pointer"
                    >
                      Cấu hình quyền hạn
                    </ListItem>
                  </>
                )}
              </>
            )}
            {(isAdmin || isSale || isAccountant) && (
              <ListItem
                onClick={handleOpenDeviceWarehouse}
                className="border-bottom list-menu-device cursor-pointer"
              >
                Đến kho thiết bị
              </ListItem>
            )}
            {!isCustomerCare && (
              <ListItem
                onClick={() => handleWarehouseTransfer()}
                className={clsx("list-menu-device cursor-pointer", canManage && "border-bottom")}
              >
                Chuyển kho
              </ListItem>
            )}
            {(isAdmin || isAgency) && (
              <ListItem
                onClick={handleDeleteAgency}
                className="cursor-pointer list-menu-device"
              >
                <span className="text-danger"> Xóa </span>
              </ListItem>
            )}
          </List>
        </Typography>
      </Popover>
    </StyledTableCell>
  );

  return (
    <>
      {openEditModal && (<EditAgency open={openEditModal} agencySelected={itemCurrent} onClose={closeModalEdit} />)}

      {openTransferModal && (<WarehouseTransfer open={openTransferModal} itemSelected={itemCurrent} onClose={closeModalTransfer} />)}

      {openConfigPackageModal && (
        <ConfigServicePackageModal
          open={openConfigPackageModal}
          agencySelected={itemCurrent}
          onClose={closeModalConfigPackage}
        />
      )}

      {openTopupModal && (
        <TopupAgencyModal
          open={openTopupModal}
          agencySelected={itemCurrent}
          onClose={closeModalTopup}
          onRefresh={() => dispatch(getListAgencies(currentParams))}
        />
      )}

      {openAgencyConfigModal && (
        <AgencyConfigModal
          open={openAgencyConfigModal}
          agencySelected={itemCurrent}
          onClose={() => setOpenAgencyConfigModal(false)}
        />
      )}

      <AgencyAccountInfoDialog
        open={Boolean(accountInfo)}
        accountInfo={accountInfo}
        onClose={() => setAccountInfo(null)}
      />

      <DialogConfirm
        title={
          confirmType === 'reset-password'
            ? MESSAGE.CONFIRM_RESET_PASSWORD_AGENCY
            : confirmType === 'disable'
            ? MESSAGE.CONFIRM_DISABLE_AGENCY
            : confirmType === 'enable'
            ? MESSAGE.CONFIRM_ENABLE_AGENCY
            : MESSAGE.CONFIRM_DELETE_AGENCY
        }
        textOk={MESSAGE.BTN_YES}
        textCancel={MESSAGE.BTN_CANCEL}
        content={
          confirmType === 'reset-password'
            ? MESSAGE.CONTENT_RESET_PASSWORD_AGENCY
            : confirmType === 'disable'
            ? `Bạn có chắc chắn muốn vô hiệu hóa tài khoản "${itemCurrent?.name || itemCurrent?.username || itemCurrent?.phone || ''}" không ?`
            : confirmType === 'enable'
            ? `Bạn có chắc chắn muốn khôi phục tài khoản "${itemCurrent?.name || itemCurrent?.username || itemCurrent?.phone || ''}" không ?`
            : MESSAGE.CONTENT_DELETE_AGENCY
        }
        callbackOk={
          confirmType === 'reset-password'
            ? confirmResetPassword
            : confirmType === 'disable'
            ? confirmDisable
            : confirmType === 'enable'
            ? confirmEnable
            : confirmDelete
        }
        callbackCancel={handleCloseDialogConfirm}
      />

      <Card className={clsx(classes.root, className)}>
        <div>
          {rowsSelected.length > 0 && (
            <Fade in={rowsSelected.length > 0}>
              <Box
                minWidth={1050}
                style={{ fontSize: '14px', padding: '6px' }}
              >
                <span>
                  <Checkbox
                    checked={rowsSelected.length > 0}
                    onChange={() => checkAll()}
                    color="primary"
                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                  />
                </span>

                {(isAdmin || isAgency) && (
                  <span
                    onClick={handleDeleteMultiAgency}
                    className="mx-2 btnDevice"
                    color="primary"
                    variant="outlined"
                    size="small"
                  >
                    <img
                      src={`/static/iconSvg/delete-icon.svg`}
                      alt="delete"
                      style={{ paddingRight: '5px', paddingBottom: '4px' }}
                    />
                    <span className="pt-1"> Xóa </span>
                  </span>
                )}
              </Box>
            </Fade>
          )}
          <PerfectScrollbar>
            {listAgencies && listAgencies.length ? (
              <Box
                ref={dragScrollRef}
                className={clsx(classes.tableScroll, classes.dragScroll)}
                minWidth={1050}
                onScroll={e => setIsScrolledX(e.currentTarget.scrollLeft > 0)}
              >
                <Table>
                  <colgroup>
                    {COLUMN_WIDTHS.map((width, index) => (
                      <col key={index} style={{ width, minWidth: width }} />
                    ))}
                  </colgroup>
                  {rowsSelected.length === 0 && listAgencies?.length > 0 && (
                    <TableHead>
                      <TableRow>
                        <StyledTableCell
                          className={clsx(classes.checkboxCell, stickyCheckboxClass)}
                          style={{ zIndex: 3 }}
                        >
                          <Checkbox
                            checked={rowsSelected.length > 0}
                            onChange={() => checkAll()}
                            color="primary"
                            inputProps={{
                              'aria-label': 'secondary checkbox'
                            }}
                          />
                        </StyledTableCell>
                        <StyledTableCell width={320} className={stickyNameClass} style={{ minWidth: 320, zIndex: 3 }}>
                          Tên đại lý
                        </StyledTableCell>
                        <StyledTableCell width={120}>
                          Số điện thoại
                        </StyledTableCell>
                        <StyledTableCell width={120}>
                          Tên đăng nhập
                        </StyledTableCell>
                        <StyledTableCell  width={180} style={{ minWidth: 180 }}>
                          Tên doanh nghiệp
                        </StyledTableCell>
                        <StyledTableCell width={100} style={{ minWidth: 100 }}>
                          Mã số thuế
                        </StyledTableCell>
                        <StyledTableCell width={160} style={{ minWidth: 160 }}>Email</StyledTableCell>
                        <StyledTableCell width={400} style={{ minWidth: 400 }}>Địa chỉ</StyledTableCell>
                        <StyledTableCell width={100} style={{ minWidth: 100 }}>
                          Tỉnh thành
                        </StyledTableCell>
                        <StyledTableCell width={120}>
                          Số dư Vxu
                        </StyledTableCell>
                        <StyledTableCell width={80}>
                          Đã kích hoạt
                        </StyledTableCell>
                        <StyledTableCell width={80}>
                          Thiết bị
                        </StyledTableCell>
                         <StyledTableCell width={120} style={{ minWidth: 120 }}>
                          Tổng đã mua
                        </StyledTableCell>
                        <StyledTableCell width={120} style={{ minWidth: 120 }}>
                          Đã trả
                        </StyledTableCell>
                        <StyledTableCell width={120} style={{ minWidth: 120 }}>
                          Dư nợ
                        </StyledTableCell>
                        <StyledTableCell width={140}>
                          Trạng thái
                        </StyledTableCell>
                        <StyledTableCell width={50} className={classes.stickyAction} style={{ zIndex: 3 }}>
                          Hành động
                        </StyledTableCell>
                      </TableRow>
                    </TableHead>
                  )}
                  <TableBody>
                    {listAgencies.map((agency) => {
                      const hasChildren = agency.children && agency.children.length > 0;
                      const isExpanded = Boolean(expandedRows[agency.id]);

                      return (
                        <React.Fragment key={agency.id}>
                          <TableRow hover>
                            <StyledTableCell
                              className={clsx(classes.checkboxCell, stickyCheckboxClass)}
                              style={{ backgroundColor: '#fff' }}
                              onClick={() => select(agency?.id)}
                            >
                              <Checkbox
                                checked={checked(agency.id)}
                                onChange={() => select(agency.id)}
                                color="primary"
                                inputProps={{
                                  'aria-label': 'secondary checkbox'
                                }}
                              />
                            </StyledTableCell>
                            <StyledTableCell className={stickyNameClass} style={{ backgroundColor: '#fff' }}>
                              <div style={{ display: 'flex', alignItems: 'center' }}>
                                {hasChildren ? (
                                  <IconButton
                                    size="small"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      toggleExpand(agency.id);
                                    }}
                                    style={{ padding: 2, marginRight: 6, flexShrink: 0 }}
                                  >
                                    {isExpanded ? (
                                      <RemoveCircleOutlineIcon style={{ fontSize: 18, color: '#e53935' }} />
                                    ) : (
                                      <AddCircleOutlineIcon style={{ fontSize: 18, color: '#B0B9C2' }} />
                                    )}
                                  </IconButton>
                                ) : (
                                  <IconButton
                                    size="small"
                                    disableRipple
                                    style={{ padding: 2, marginRight: 6, flexShrink: 0, cursor: 'not-allowed', opacity: 0.35 }}
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    <AddCircleOutlineIcon style={{ fontSize: 18, color: '#666666' }} />
                                  </IconButton>
                                )}
                                {agency?.name ? (
                                  <Tooltip title={agency.name} placement="top" arrow interactive>
                                    <div className={classes.clampText}>
                                      {agency.name}
                                    </div>
                                  </Tooltip>
                                ) : (
                                  '-'
                                )}
                              </div>
                            </StyledTableCell>
                            <StyledTableCell>
                              {agency?.leader?.phone || '-'}
                            </StyledTableCell>
                            <StyledTableCell>
                              {agency?.leader?.username || '-'}
                            </StyledTableCell>
                            <StyledTableCell>
                              {agency?.leader?.business_name || '-'}
                            </StyledTableCell>
                            <StyledTableCell>
                              {agency?.leader?.tax_code || '-'}
                            </StyledTableCell>
                            <StyledTableCell>
                              {agency?.leader?.email ? (
                                <Tooltip title={agency.leader.email} placement="top" arrow interactive>
                                  <div className={classes.clampText}>
                                    {agency.leader.email}
                                  </div>
                                </Tooltip>
                              ) : (
                                '-'
                              )}
                            </StyledTableCell>
                            <StyledTableCell>
                              {agency?.leader?.address ? (
                                <Tooltip title={agency.leader.address} placement="top" arrow interactive>
                                  <div className={classes.clampText}>
                                    {agency.leader.address}
                                  </div>
                                </Tooltip>
                              ) : (
                                '-'
                              )}
                            </StyledTableCell>
                            <StyledTableCell>
                              {getProvinceAddress(agency?.leader?.citizen_id) ||
                                '-'}
                            </StyledTableCell>
                            <StyledTableCell>
                              {Number(agency?.level) === 1 ? formatCurrency(agency?.wallet?.balance) : '-'}
                            </StyledTableCell>
                            <StyledTableCell>
                              {agency?.deviceActive || '-'}
                            </StyledTableCell>
                            <StyledTableCell>
                              {agency?.devicesTotal || '-'}
                            </StyledTableCell>
                            <StyledTableCell>
                              {formatAgencyMoney(agency?.money?.total_amount_sum)}
                            </StyledTableCell>
                            <StyledTableCell>
                              {formatAgencyMoney(agency?.money?.total_paid_sum)}
                            </StyledTableCell>
                            <StyledTableCell>
                              {formatAgencyMoney(getAgencyDebt(agency?.money))}
                            </StyledTableCell>
                            {renderStatusCell(agency)}
                            {renderActionsCell(agency)}
                          </TableRow>
                          {isExpanded && hasChildren && agency.children.map((child) => {
                            const isChildExpanded = Boolean(expandedRows[child.id]);
                            const hasChildChildren = child.children && child.children.length > 0;

                            return (
                              <React.Fragment key={child.id}>
                                <TableRow hover style={{ backgroundColor: '#f8fafc' }}>
                                  <StyledTableCell
                                    className={clsx(classes.checkboxCell, stickyCheckboxClass)}
                                    style={{ backgroundColor: '#f8fafc' }}
                                    onClick={() => select(child?.id)}
                                  >
                                    <Checkbox
                                      checked={checked(child.id)}
                                      onChange={() => select(child.id)}
                                      color="primary"
                                      inputProps={{
                                        'aria-label': 'secondary checkbox'
                                      }}
                                    />
                                  </StyledTableCell>
                                  <StyledTableCell className={stickyNameClass} style={{ backgroundColor: '#f8fafc' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', paddingLeft: 36 }}>
                                      {hasChildChildren ? (
                                        <IconButton
                                          size="small"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            toggleExpand(child.id);
                                          }}
                                          style={{ padding: 2, marginRight: 6, flexShrink: 0 }}
                                        >
                                          {isChildExpanded ? (
                                            <RemoveCircleOutlineIcon style={{ fontSize: 18, color: '#e53935' }} />
                                          ) : (
                                            <AddCircleOutlineIcon style={{ fontSize: 18, color: '#B0B9C2' }} />
                                          )}
                                        </IconButton>
                                      ) : (
                                        <IconButton
                                          size="small"
                                          disableRipple
                                          style={{ padding: 2, marginRight: 6, flexShrink: 0, cursor: 'not-allowed', opacity: 0.35 }}
                                          onClick={(e) => e.stopPropagation()}
                                        >
                                          <AddCircleOutlineIcon style={{ fontSize: 18, color: '#666666' }} />
                                        </IconButton>
                                      )}
                                      {child?.name ? (
                                        <Tooltip title={child.name} placement="top" arrow interactive>
                                          <div className={classes.clampText}>
                                            {child.name}
                                          </div>
                                        </Tooltip>
                                      ) : (
                                        '-'
                                      )}
                                    </div>
                                  </StyledTableCell>
                              <StyledTableCell>
                                {child?.leader?.phone || '-'}
                              </StyledTableCell>
                              <StyledTableCell>
                                {child?.leader?.username || '-'}
                              </StyledTableCell>
                              <StyledTableCell>
                                {child?.leader?.business_name || '-'}
                              </StyledTableCell>
                              <StyledTableCell>
                                {child?.leader?.tax_code || '-'}
                              </StyledTableCell>
                              <StyledTableCell>
                                {child?.leader?.email ? (
                                  <Tooltip title={child.leader.email} placement="top" arrow interactive>
                                    <div className={classes.clampText}>
                                      {child.leader.email}
                                    </div>
                                  </Tooltip>
                                ) : (
                                  '-'
                                )}
                              </StyledTableCell>
                              <StyledTableCell>
                                {child?.leader?.address ? (
                                  <Tooltip title={child.leader.address} placement="top" arrow interactive>
                                    <div className={classes.clampText}>
                                      {child.leader.address}
                                    </div>
                                  </Tooltip>
                                ) : (
                                  '-'
                                )}
                              </StyledTableCell>
                              <StyledTableCell>
                                {getProvinceAddress(child?.leader?.citizen_id) ||
                                  '-'}
                              </StyledTableCell>
                              <StyledTableCell>
                                {Number(child?.level) === 1 ? formatCurrency(child?.wallet?.balance) : '-'}
                              </StyledTableCell>
                              <StyledTableCell>
                                {child?.deviceActive || '-'}
                              </StyledTableCell>
                              <StyledTableCell>
                                {child?.devicesTotal || '-'}
                              </StyledTableCell>
                              <StyledTableCell>
                                {formatAgencyMoney(child?.money?.total_amount_sum)}
                              </StyledTableCell>
                              <StyledTableCell>
                                {formatAgencyMoney(child?.money?.total_paid_sum)}
                              </StyledTableCell>
                              <StyledTableCell>
                                {formatAgencyMoney(getAgencyDebt(child?.money))}
                              </StyledTableCell>

                              {renderStatusCell(child)}
                              {renderActionsCell(child, '#f8fafc')}
                            </TableRow>
                            </React.Fragment>
                          );
                        })}
                        </React.Fragment>
                      );
                    })}
                  </TableBody>
                </Table>
              </Box>
            ) : (
              <div className="text-center pb-5">
                <img src="/static/empty.png" class="justify-content-center" />
                <h5>
                  {isCustomerCare && !currentParams?.keywords
                    ? 'Vui lòng nhập tên, số điện thoại hoặc email để tìm kiếm'
                    : 'Danh sách trống'}
                </h5>
              </div>
            )}
          </PerfectScrollbar>
        </div>
      </Card>
      {listAgencies && listAgencies.length > 0 && (
        <div class="mt-3 mr-4 float-right">
          <Box
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '15px'
            }}
          >
            <Typography style={{ fontSize: '14px' }}>
              Tổng: {totalAgencies}
            </Typography>
            <Pagination
              count={Math.ceil(totalAgencies / limit)}
              color="primary"
              size="small"
              onChange={handlePageChange}
              page={Number(params.page) || 1}
              siblingCount={isMobile ? 0 : 1}
              boundaryCount={isMobile ? 1 : 2}
              showFirstButton={!isMobile}
              showLastButton={!isMobile}
            />
          </Box>
        </div>
      )}
    </>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  listAgencies: PropTypes.array.isRequired,
  currentParams: PropTypes.object
};

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    '&.MuiPaper-elevation1': {
      boxShadow: 'none'
    }
  },
  groupAction: {
    display: 'flex',
    alignItems: 'center',
    '& .action': {
      cursor: 'pointer',
      padding: '0 5px',
      '&:hover': {
        color: '#3f51b5'
      }
    }
  },
  minWithColumn: {
    minWidth: '150px'
  },
  actionMenuPaper: {
    backgroundColor: '#f5f7fa',
    border: '1px solid #e1e5eb',
    borderRadius: '8px',
    boxShadow: '0 6px 16px rgba(0, 0, 0, 0.12) !important',
    '& .list-menu-device:hover': {
      backgroundColor: '#e8ecf2'
    }
  },
  
  checkboxCell: {
    boxSizing: 'border-box',
    width: CHECKBOX_COL_WIDTH,
    minWidth: CHECKBOX_COL_WIDTH,
    maxWidth: CHECKBOX_COL_WIDTH
  },
  stickyCheckbox: {
    position: 'sticky',
    left: 0,
    zIndex: 2
  },
  stickyName: {
    position: 'sticky',
    left: CHECKBOX_COL_WIDTH,
    zIndex: 2,
    boxShadow: 'inset -1px 0 0 #dcdfe6, 8px 0 10px -6px rgba(0, 0, 0, 0.22)'
  },
  stickyAction: {
    position: 'sticky',
    right: 0,
    zIndex: 2,
    textAlign: 'center',
    boxShadow: 'inset 1px 0 0 #dcdfe6, -8px 0 10px -6px rgba(0, 0, 0, 0.22)'
  },
  dragScroll: {
    cursor: 'grab'
  },
  tableScroll: {
    overflowX: 'auto',
    scrollbarWidth: 'auto',
    scrollbarColor: '#d0d0d0 #f7f7f7',
    '&::-webkit-scrollbar': {
      height: '14px'
    },
    '&::-webkit-scrollbar-track': {
      background: '#f7f7f7',
      borderRadius: '7px'
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#d0d0d0',
      borderRadius: '7px',
      border: '3px solid #f7f7f7',
      minWidth: '60px',
      cursor: 'pointer',
      '&:hover': {
        background: '#b5b5b5'
      },
      '&:active': {
        background: '#a0a0a0'
      }
    }
  },
  clampText: {
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word',
    maxHeight: '2.8em',
    lineHeight: '1.4em'
  },
  statusChip: {
    height: '24px',
    fontSize: '12.5px',
    fontWeight: 600,
    borderRadius: '6px',
    letterSpacing: '0.2px'
  },
  statusChipActive: {
    backgroundColor: 'rgba(76, 175, 80, 0.12)',
    color: '#2e7d32'
  },
  statusChipDisabled: {
    backgroundColor: 'rgba(244, 67, 54, 0.12)',
    color: '#c62828'
  }
}));

export default React.memo(Results);
